import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
var axios_instance_download_IT_template = get_axios_instance(api_variables.SERVICE_IT_TEMPLATE_DOWNLOAD);
// import Vue from 'vue';
/*
Author: 
Date: 
Description: 
*/

var axios_instance_set_plan_name = get_axios_instance(api_variables.SERVICE_CREATE_PLAN); // PL_3064  // 
var axios_instance_lop = get_axios_instance(api_variables.SERVICE_REPORTS_LOP);
var axios_instance_ctc = get_axios_instance(api_variables.SERVICE_REPORTS_CTC);
var axios_instance_variance = get_axios_instance(api_variables.SERVICE_REPORTS_VARIANCE);
var axios_instance_jv = get_axios_instance(api_variables.SERVICE_REPORTS_JV);
var axios_instance_hc = get_axios_instance(api_variables.SERVICE_REPORTS_HC);
var axios_instance_ba = get_axios_instance(api_variables.SERVICE_REPORTS_BA);
var axios_instance_bt = get_axios_instance(api_variables.SERVICE_REPORTS_BT);
var axios_instance_tds = get_axios_instance(api_variables.SERVICE_REPORTS_TDS); //PL_2410
var axios_instance_statutory = get_axios_instance(api_variables.SERVICE_REPORTS_STATUTORY);
var get_emp_by_id_axios_instance = get_axios_instance(api_variables.SERVICE_GET_EMPLOYEE);
var get_emp_plan_list = get_axios_instance(api_variables.SERVICE_GET_PLAN);
var get_it_data = get_axios_instance(api_variables.SERVICE_GET_IT_DATA);
var axios_instance_create_it_plan = get_axios_instance(api_variables.CREATE_IT_PLAN_DATA);
var axios_instance_activate_plan = get_axios_instance(api_variables.ACTIVATE_PLAN);
var axios_instance_get_plan_id = get_axios_instance(api_variables.SERVICE_GET_PLAN_ID);
var get_axios_instance_active_plan = get_axios_instance(api_variables.GET_ACTIVE_PLAN);
var axios_instance_upload_forms = get_axios_instance(api_variables.UPLOAD_DECLARATION_FORM);
//var axios_instance_get_plan_name = get_axios_instance(api_variables.GET_PLAN_NAME);
var axios_instance_it_enable = get_axios_instance(api_variables.SERVICE_IT_ENABLE);
var axios_instance_it_bulk_upload = get_axios_instance(api_variables.IT_SERVICE_BULK_UPLOAD);
var get_axios_instance_get_dependents = get_axios_instance(api_variables.SERVICE_GET_DEPENDENTS);
var get_axios_instance_create_dependents = get_axios_instance(api_variables.SERVICE_CREATE_DEPENDENTS);
var get_axios_instance_delete_dependents = get_axios_instance(api_variables.SERVICE_DEPENDENTS_DELETE);
var get_axios_instance_update_dependents = get_axios_instance(api_variables.SERVICE_DEPENDENTS_UPDATE);
var axios_instance_get_approval_bulK_template = get_axios_instance(api_variables.SERVICE_IT_PROOF_BULK_DOWNLOAD);
var axios_instance_upload_approval_template = get_axios_instance(api_variables.SERVICE_IT_PROOF_BULK_UPLOAD);
var axios_instance_download_it_declared_details = get_axios_instance(api_variables.SERVICE_DOWNLOAD_IT_DECLARATION_DETAILS);
var axios_instance_download_it_submission_details=get_axios_instance(api_variables.SERVICE_DOWNLOAD_IT_SUBMISSION_DETAILS)
var axios_instance_download_it_proof_details = get_axios_instance(api_variables.SERVICE_DOWNLOAD_IT_PROOF_DETAILS)
var axios_instance_download_it_proof_submitted_details = get_axios_instance(api_variables.SERVICE_DOWNLOAD_IT_PROOF_SUBMITTED_DETAILS)
var axios_instance_download_it_declaration_it_sheet = get_axios_instance(api_variables.SERVICE_ESS_IT_DECLARATION_IT_SHEET)
var axios_instance_tax_campare_sheet = get_axios_instance(api_variables.SERVICE_TAX_COMPARE)

const state = {
    data: [],
    isFetching: false,
};
const getters = {

    record: (state) => {
        return state.data;
    }
}
const mutations = {
    set: (state, payload) => {
        state.data = payload;

    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

}

const updatePlanToken = () => {
    let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
    get_emp_plan_list.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const updateDataToken = () => {
    let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
    get_it_data.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const actions = {

    async create({ commit }, payload) {
        try {

            let res = await axios_instance_upload_forms.post("/", payload);

            if (res.status == 200) {
                // commit("addEmployee", payload);
            }
            return res;
        } catch (err) {
            //console.log(err);
        }
    },

    async it_bulk(payload) {
        try {

            let res = await axios_instance_it_bulk_upload.post('/', payload);

            //console.log("IT bulk", res)
            return res;
        } catch (err) {
            //console.log(err);
            return err;
        }
    },

    async fetchEmpDataById({ commit }, payload) {
        try {
            let res = await get_emp_by_id_axios_instance.get(`/${payload}`);
            commit("setempObj", res.data.payload.emp);
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
    async getPlanName({ commit }, payload) {
        try {
            let res = await axios_instance_get_plan_id.get('/', {
                params: {
                    it_plan_id: payload,
                }
            });
            if (res) {
                return res;
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async activatePlan({ commit }, payload) {
        try {

            let res = await axios_instance_activate_plan.post('/', payload);

            if (res.data.status) {

                return res;
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async getPlan({ commit }, payload) {
        updatePlanToken();
        try {
            let res = await get_emp_plan_list.get('/', {
                params: {
                    employee_id: payload
                }
            });
            // PL_3064
            if (res.data.status) {

                return res;
            }
        } catch (error) {
            //return res;
            return errorHandler(error.response);

        }
    },
    async setItData({ commit }, payload) {
        try {
            updateDataToken();
            commit("setFetching", true);
            let res = await get_it_data.get('/', {
                params: {
                    le_id: payload.le_id,
                    employee_id: payload.employee_id,
                    financial_year: payload.financial_year,
                    it_plan_id: payload.it_plan_id
                }
            });
            commit("setFetching", false);
            // PL_3064
            if (res.data.status) {

                commit("set", res.data.payload);
                return res;
            }
        } catch (error) {
            //return res;
            return errorHandler(error.response);

        }
    },
    async getActiveList({ commit }, payload) {
        try {

            let res = await get_axios_instance_active_plan.get('/', {
                params: {
                    employee_id: payload,
                }
            });

            if (res.data.status) {
                return res;
            }
        } catch (error) {
            //return res;
            return errorHandler(error.response);

        }
    },
    async setPlanName({ commit }, payload) {
        try {

            let res = await axios_instance_set_plan_name.post('/', payload);

            if (res.data.status) {

                return res;
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async createItData({ commit }, payload) {
        try {
            //console.log("inside the api call");
            let res = await axios_instance_create_it_plan.post('/', { payload });

            if (res.data.status) {

                return res;
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    // async getPlanId({ commit }, payload) {
    //     try {
    //         let res = await axios_instance_get_plan_id.get(``, {
    //             params: {
    //                 it_plan_id:payload
    //             }
    //           });
    //         if (res.data.status) {
    //            //console.log("ID of plans",res);
    //            return res;
    //         }
    //     } catch (error) {
    //         //return res;
    //         return  errorHandler(error.response);

    //         }
    //     },

    async downloadLOPReport({ commit }, payload) {
        try {
            let res = await axios_instance_lop.post('/', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", "LOP_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadSalaryCTCReport({ commit }, payload) {
        try {
            let res = await axios_instance_ctc.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", "CTC_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadVarianceReport({ commit }, payload) {
        try {
            let res = await axios_instance_variance.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", "Variance_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadJVReport({ commit }, payload) {
        try {
            let res = await axios_instance_jv.post('', payload);
            // const res.data.payload.Location = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", "JV_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadHCReport({ commit }, payload) {
        try {
            let res = await axios_instance_hc.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", "Head_Count_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadBAReport({ commit }, payload) {
        try {
            let res = await axios_instance_ba.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", "Salary_Bank_Advise_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadBTReport({ commit }, payload) {
        try {
            let res = await axios_instance_bt.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", "Bank_advise_transfer_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    // PL_2410
    async downloadTDSReport({ commit }, payload) {
        try {
            let res = await axios_instance_tds.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", "TDS_Report.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadStatutoryReports({ commit }, payload) {
        try {
            let res = await axios_instance_statutory.post('', payload);
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload.Location;
                link.setAttribute("download", payload.data.report + ".xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async getItEnable({ commit }, payload) {
        try {
            let res = await axios_instance_it_enable.get('/', {
                params: {
                    le_id: payload.le_id,
                }
            });
            if (res) {
                return res;
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async getDependentList({ commit }, payload) {
        try {
            let res = await get_axios_instance_get_dependents.get('', {
                params: {
                    it_plan_id: payload.it_plan_id,
                    employee_id: payload.employee_id
                }
            });
            if (res.data.status) {
                return res;
            }
        } catch (error) {
            //return res;
            return errorHandler(error.response);
        }
    },

    async createDependents({ commit }, payload) {
        try {
            let res = await get_axios_instance_create_dependents.post("/", payload);
            if (res.status == 200) {
                // commit("addEmployee", payload);
            }
            return res;
        } catch (err) {
            //console.log(err);
        }
    },

    async deleteDependents({ commit }, payload) {
        try {
            let res = await get_axios_instance_delete_dependents.post('/', {
                id: payload,
            });
            if (res.status == 200) {
                // commit("removeEntityById", payload.id);
            }
            return res;
        } catch (error) {
            //console.log('error', error);
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            let res = await get_axios_instance_update_dependents.put(`/`, payload);
            if (res.status == 200) {
                // commit("updateVoluntaryPfEmployeeById", res.data);
            }
            return res;
        } catch {

        }
    },

    async getAprrovalTemplate({commit},payload) {
        try {
          let res = await axios_instance_get_approval_bulK_template.get(``, {
            params: payload
          });
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", "IT Proof Approval"+ ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
        } catch (err) {
            throw errorHandler(error);
        }
      },

      async taxApprovalUploadTemplate({ commit }, payload) {
        try {
          commit("setFetching", true);
          let res = await axios_instance_upload_approval_template.post(``, payload);
          commit("setFetching", false);
          return res;
        } catch (err) {
          throw errorHandler(err.response);
        }
      },
      async downloadITTemplate({ commit }, payload) {
        try {
          let res = await axios_instance_download_IT_template.get(`/`, {
              params: {
                  le_id: payload.le_id,
                  financial_year: payload.financial_year
              }
          });
  
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", payload + ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
          }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async downloadItDeclaredDetails({ commit }, payload) {
        try {
          let res = await axios_instance_download_it_declared_details.get(`/`, {
              params: {
                  le_id: payload.le_id,
                  financial_year: payload.financial_year
              }
          });
          console.log(res)
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", payload + ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
          }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
     async downloadItSubmissionDetails({ commit }, payload) {
        try {
          let res = await axios_instance_download_it_submission_details.get(`/`, {
              params: {
                  le_id: payload.le_id,
                  financial_year: payload.financial_year
              }
          });
          console.log(res)
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", payload + ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
          }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
     async downloadItProofDetails({ commit }, payload) {
        try {
          let res = await axios_instance_download_it_proof_details.get(`/`, {
              params: {
                  le_id: payload.le_id,
                  financial_year: payload.financial_year ? payload.financial_year:"2025"
              }
          });
          console.log(res)
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", payload + ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
          }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
     async downloadItProofSubmittedDetails({ commit }, payload) {
        try {
          let res = await axios_instance_download_it_proof_submitted_details.get(`/`, {
              params: {
                  le_id: payload.le_id,
                  financial_year: payload.financial_year
              }
          });
          console.log(res)
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", payload + ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
          }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
     async fetchItDeclarationTimeSheet({ commit }, payload){
        try{
             let res = await  axios_instance_download_it_declaration_it_sheet.get('/',{
                params:{
                    employee_id:payload.employee_id,
                    month:payload.month,
                    financial_year:payload.financial_year,
                    legal_entity_id: payload.legal_entity_id,
                    regime_type:payload.regime_type
                }
             })
                return res.data.payload 
        }catch(err){
           throw errorHandler(err.response)
        }
     },
     async fetchTaxCompareData({ commit }, payload){
        try{
             let res = await  axios_instance_tax_campare_sheet.get('/',{
                params:{
                    employee_id:payload.employee_id,
                    month:payload.month,
                    financial_year:payload.financial_year,
                    legal_entity_id: payload.legal_entity_id
                }
             })
             return res.data.payload
        }catch(err){
           throw errorHandler(err.response)
        }
     }
}

export default {
    namespaced: true,
    actions,
    mutations,
    state,
    getters
};